// imports
import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
// components
import ProductFormulationTypeSelect from 'components/common/simpleSelectors/ProductFormulationType';
// interfaces
import { ProductFormulationTypeSelectorProps } from 'interfaces';

const ProductFormulationTypeSelector: FC<ProductFormulationTypeSelectorProps> = ({
  name,
  title,
  handleChange,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <ProductFormulationTypeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ProductFormulationTypeSelector;
